import gsap from "gsap";
import { isAuthor, isMobile } from "../../../js/utils";
import { animateWords, animateObserver, parallaxHeroHome, showHeroHome } from "../../../js/animations/animations";

(() => {
  const BRHHeroHome = () => {
    const component = {
      default: "brh-hero-home",
      class: {
        main: () => `.${component.default}`,
      },
      selector: {
        hash: "js-",
        parallaxTrigger: () => `.${component.selector.hash}hero-home-parallax-trigger`,
      },
    };

    const init = () => {
      if (!isMobile() && !isAuthor()) {
        const heroesHome = document.querySelectorAll(".js-hero-home-show");
        if (heroesHome.length > 0) {
          heroesHome.forEach((element) => {
            const timeline = gsap.timeline({
              scrollTrigger: {
                trigger: element,
                toggleActions: "restart reverse none none",
                start: "top top",
                end: "bottom top",
                // markers: true,
                scrub: true,
              },
            });
            const videosParallax = element.querySelectorAll(".brh-video__player");
            videosParallax.length > 0 && timeline.add(parallaxHeroHome({ classElement: videosParallax, trigger: ".js-hero-home-parallax-trigger" }), 0);

            const appearances = gsap.timeline();
            const heroHome = document.querySelector(".brh-hero-home");
            const title = heroHome.querySelector(".brh-hero-home__title");
            title && appearances.add(animateWords({ classElement: title, options: { types: "lines, words, chars" } }), 0);

            const videos = element.querySelectorAll(".brh-video__player");
            videos.length > 0 && appearances.add(showHeroHome(videos), 0);

            appearances.duration(1.5);
            appearances.pause();

            animateObserver({ elementToObserve: element, animation: () => appearances, threshold: 0 });
          });
        }
      }
    };
    init();
  };
  document.addEventListener("DOMContentLoaded", BRHHeroHome);
})();
